import { render } from "./Create.vue?vue&type=template&id=48c3c5d1"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Desktop/projects/ConexionCreativa/real-gestion/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__